import { render, staticRenderFns } from "./BrokerBatch.vue?vue&type=template&id=f6d8f526"
import script from "./BrokerBatch.vue?vue&type=script&lang=js"
export * from "./BrokerBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports